export default {
  filters: {
    today: 'Tänään',
    yesterday: 'Eilen',
    this_week: 'Tällä viikolla',
    last_week: 'Viime viikolla',
    this_month: 'Tässä kuussa',
    last_month: 'Viime kuussa',
    all: 'Kaikki',
  },
};
